import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { OeAppPersonService } from '../../shared/oe-app-person.service';
import { OeAppService } from '../../shared/oe-app.service';
import { isIFrameSameOrigin } from '../../shared/helpers/is-same-origin';
import { HybridClassEventType } from '../hybrid-classes-events';
import { GTMService } from '../../shared/gtm.service';
import { WindowService } from '../../shared/window.service';
import { ProfileServiceConfigurationService } from '../../shared/profile-service-configuration.service';

@Component({
  selector: 'lp2-hybrid-classes-page',
  template:
    '<iframe lp2UserwaySync *ngIf="src" id="hybrid-classes-iframe" [src]="src | safeUrl" frameborder="0" allow="microphone; autoplay; camera"></iframe>',
  styleUrls: ['./hybrid-classes-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HybridClassesPageComponent {
  private classroomId: string;
  private liveClassMaxAttendeesForChat: number;
  private liveClassPlayerSessionLockEnabled: boolean;

  public get src(): string | null {
    if (
      !this.classroomId ||
      !this.oeAppService.environment ||
      !this.oeAppPersonService.contactId ||
      this.liveClassMaxAttendeesForChat === undefined ||
      this.liveClassPlayerSessionLockEnabled === undefined
    ) {
      return null;
    }
    return `${this.oeAppService.webHybridClassesPageHost}?env=${this.oeAppService.environment}&classroomId=${this.classroomId}&contactId=${this.oeAppPersonService.contactId}&liveClassMaxAttendeesForChat=${this.liveClassMaxAttendeesForChat}&liveClassPlayerSessionLockEnabled=${this.liveClassPlayerSessionLockEnabled}`;
  }

  constructor(
    private readonly oeAppService: OeAppService,
    private readonly profileServiceConfigurationService: ProfileServiceConfigurationService,
    private readonly oeAppPersonService: OeAppPersonService,
    private readonly gtmService: GTMService,
    private readonly windowService: WindowService,
    private readonly cdr: ChangeDetectorRef
  ) {
    const urlParams = new URLSearchParams(window.location.search);
    this.classroomId = urlParams.get('classroomId');
  }

  ngOnInit() {
    this.profileServiceConfigurationService
      .liveClassMaxAttendeesForChat$()
      .subscribe((liveClassMaxAttendeesForChat) => {
        this.liveClassMaxAttendeesForChat = liveClassMaxAttendeesForChat;
        if (liveClassMaxAttendeesForChat) {
          this.cdr.detectChanges();
        }
      });
    this.profileServiceConfigurationService
      .liveClassPlayerSessionLockEnabled$()
      .subscribe((liveClassPlayerSessionLockEnabled) => {
        this.liveClassPlayerSessionLockEnabled = liveClassPlayerSessionLockEnabled;
        if (liveClassPlayerSessionLockEnabled !== undefined) {
          this.cdr.detectChanges();
        }
      });
    window.addEventListener('message', this.handleEvents, false);
  }

  ngOnDestroy() {
    window.removeEventListener('message', this.handleEvents);
  }

  private handleEvents = ({ data, origin }) => {
    if (!isIFrameSameOrigin(this.oeAppService.webHybridClassesPageHost, origin)) {
      return;
    }

    switch (data.type) {
      case HybridClassEventType.HYBRID_CLASS_CLOSE_EVENT:
        this.windowService.redirectToHref('/');
        break;
      case HybridClassEventType.HYBRID_CLASS_TRACKING_EVENT:
        this.gtmService.sendGA4Event(data.data);
        break;
    }
  };
}



// WEBPACK FOOTER //
// ./ts/app/hybrid-classes/hybrid-classes-page/hybrid-classes-page.component.ts